import styled from 'styled-components';

export const HeaderStyles = styled.div`
  padding: 10px 0 15px;
  z-index: 99;
  .header-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1340px;
    margin: 0 auto;
  }
  .header-right {
    display: flex;
    justif
  }
  .phone {
    margin: 0 30px 0 0;
    a {
      line-height: 35px;
      color: white;
    }
  }
  &.white-background {
    background-color: white;
    color: ${props => props.theme.gray800};
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
    .phone {
      a {
        color: ${props => props.theme.gray800};
      }
    }
  }
`;
